import { useMemo } from "react";

export default function PermissionMatrix({
  permissions = [],
  selectedPermissions = [],
  setSelectedPermissions,
}) {
  const groupedPermissions = useMemo(() => {
    const groups = {};

    (Array.isArray(permissions) ? permissions : []).forEach((permission) => {
      const module = permission.module || "Others";

      if (!groups[module]) {
        groups[module] = [];
      }

      groups[module].push(permission);
    });

    return groups;
  }, [permissions]);

  const togglePermission = (slug) => {
    if (selectedPermissions.includes(slug)) {
      setSelectedPermissions(
        selectedPermissions.filter((p) => p !== slug)
      );
    } else {
      setSelectedPermissions([...selectedPermissions, slug]);
    }
  };

  const toggleGroup = (modulePermissions) => {
    const permissionSlugs = modulePermissions.map((p) => p.slug);

    const allSelected = permissionSlugs.every((slug) =>
      selectedPermissions.includes(slug)
    );

    if (allSelected) {
      setSelectedPermissions(
        selectedPermissions.filter(
          (slug) => !permissionSlugs.includes(slug)
        )
      );
    } else {
      setSelectedPermissions([
        ...new Set([
          ...selectedPermissions,
          ...permissionSlugs,
        ]),
      ]);
    }
  };

  return (
    <div className="mt-6">
      <h3 className="mb-4 text-lg font-semibold">
        Permissions
      </h3>

      {Object.keys(groupedPermissions).length === 0 && (
        <div className="rounded-lg border border-gray-200 p-5 text-center text-gray-500">
          No permissions found.
        </div>
      )}

      {Object.entries(groupedPermissions).map(
        ([module, modulePermissions]) => {
          const permissionSlugs = modulePermissions.map(
            (p) => p.slug
          );

          const allSelected = permissionSlugs.every((slug) =>
            selectedPermissions.includes(slug)
          );

          return (
            <div
              key={module}
              className="mb-6 overflow-hidden rounded-xl border border-gray-200"
            >
              <div className="flex items-center justify-between bg-gray-100 px-4 py-3">
                <h4 className="text-lg font-semibold capitalize">
                  {module.replace(/_/g, " ")}
                </h4>

                <label className="flex cursor-pointer items-center gap-2">
                  <input
                    type="checkbox"
                    checked={allSelected}
                    onChange={() => toggleGroup(modulePermissions)}
                  />
                  <span className="text-sm font-medium">
                    Select All
                  </span>
                </label>
              </div>

              <div className="grid grid-cols-1 gap-3 p-4 md:grid-cols-2 lg:grid-cols-3">
                {modulePermissions.map((permission) => (
                  <label
                    key={permission.id}
                    className="flex cursor-pointer items-center gap-3 rounded-lg border border-gray-200 p-3 transition hover:bg-gray-50"
                  >
                    <input
                      type="checkbox"
                      checked={selectedPermissions.includes(
                        permission.slug
                      )}
                      onChange={() =>
                        togglePermission(permission.slug)
                      }
                    />

                    <div>
                      <div className="font-medium">
                        {permission.name}
                      </div>

                      <div className="text-xs text-gray-500">
                        {permission.slug}
                      </div>
                    </div>
                  </label>
                ))}
              </div>
            </div>
          );
        }
      )}
    </div>
  );
}